import { create } from 'zustand';

/**
 * The drag image: what the pointer is carrying, and where.
 *
 * Only `DragLayer` reads this, so a drag repaints one small component per
 * frame instead of every icon it passes over. The *highlight* on the folder
 * under the cursor is set straight onto that element by `drag.ts` for the same
 * reason — nothing else needs to re-render at all.
 */

export interface DragGhost {
  path: string;
  icon: string;
  label: string;
  /** How wide the cell was, so a tile's ghost stays a tile. */
  w: number;
  iconSize: number;
  /** Label beside the icon rather than under it: list and tile cells. */
  inline: boolean;
  /** Where this icon sat relative to the pointer when it was picked up. */
  dx: number;
  dy: number;
}

export interface DragState {
  active: boolean;
  ghosts: DragGhost[];
  /** Pointer position, in client coordinates. */
  x: number;
  y: number;
  /** False over anything that would refuse the drop, for the no-entry cursor. */
  valid: boolean;
}

const IDLE: DragState = { active: false, ghosts: [], x: 0, y: 0, valid: false };

export const useDragStore = create<DragState>(() => IDLE);

export function clearDrag(): void {
  useDragStore.setState(IDLE);
}
